module.exports = __webpack_public_path__ + "static/media/Nutcracker.55b5f8b7.jpg";